import { Component, OnInit, Input } from '@angular/core';
import { CaseService } from '../../../../shared/services/case.service';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { LettersService } from '../../../../shared/services/letters.service';
import { UserService } from '../../../../shared/services/user.service';
import { ComparerService } from '../../../../shared/utility/comparer';
import { AuditService } from '../../../../shared/services/audit.service';
import { CorrespondenceTimelineService } from '../../../../shared/services/correspondence-timeline.service';
import { faHistory} from '@fortawesome/pro-light-svg-icons';
import { AuditFormComponent } from '../../../audit-form/audit-form.component';
import { AuthService } from '../../../../auth/auth.service';
import { ModalService } from 'src/app/shared/services/modal.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-conveyancing-sale-estate-agent-details',
  templateUrl: './conveyancing-sale-estate-agent-details.component.html',
  styleUrls: ['./conveyancing-sale-estate-agent-details.component.scss']
})
export class ConveyancingSaleEstateAgentDetailsComponent implements OnInit {

  @Input() caseId: number;

  viewInit = false;
  faUsers: any[] = [];
  faHistory = faHistory;

  generatingLetters: boolean = false;

  estateAgentDetails = this.fb.group({
    conveyancingSaleCaseId: [],
    caseId: [],
    addedByUser:[],
    addedByUserId: [],
    userCompanyId: [],
    userCompanyName: '',
    externalReference: '',
    contactNumber: '',
    estateAgentFee : [],
    estateAgentAddressLine1 : [],
    estateAgentAddressLine2 : [],
    estateAgentAddressLine3 : [],
    estateAgentAddressLine4 : [],
    estateAgentAddressLine5 : [],
    estateAgentPostcode : []
  }, { });

  initialForm = this.fb.group({
    conveyancingSaleCaseId: [],
    caseId: [],
    addedByUser:[],
    addedByUserId: [],
    userCompanyId: [],
    userCompanyName: '',
    externalReference: '',
    contactNumber: '',
    estateAgentFee : [],
    estateAgentAddressLine1 : [],
    estateAgentAddressLine2 : [],
    estateAgentAddressLine3 : [],
    estateAgentAddressLine4 : [],
    estateAgentAddressLine5 : [],
    estateAgentPostcode : []
  }, { });

  constructor(
              public activeModal: NgbActiveModal,
              private caseService: CaseService,
              private fb: UntypedFormBuilder,
              private userService: UserService,
              private lettersService: LettersService,
              private comp: ComparerService,
              private auditService: AuditService,
              private correspondenceTimelineService: CorrespondenceTimelineService,
              public authService: AuthService,
              private modalService: ModalService) {
  }

  ngOnInit(): void {
      this.caseService.getConveyancingSaleEstateAgentDetails(this.caseId).subscribe(response => {

      this.estateAgentDetails.patchValue(response.estateAgentDetails);
      this.initialForm.patchValue(response.estateAgentDetails);

      this.userService.companyGroupUsers(response.estateAgentDetails.userCompanyId).subscribe(result => {
        this.faUsers = result;
      });
    });

    this.estateAgentDetails.get('addedByUserId')!.valueChanges.subscribe(value => {

      this.userService.basicUserDetails(value).subscribe(result => {
        this.estateAgentDetails.controls["addedByUser"].patchValue(result);
      });
    });
  }

  updateField(){


    this.caseService.updateConveyancingSaleEstateAgentDetails(this.estateAgentDetails.value).subscribe((response : any) => {

    }, (error : any) => {


    });

  }

  createLetters(){

    this.generatingLetters = true;

    this.lettersService.generateLettersForGroup(this.caseId, 6).subscribe((response : any) => {

      this.correspondenceTimelineService.refreshCaseTimeline.next();
      this.close();


    }, (error : any) => {


    });
  }

  close(){

    if(this.comp.objectsDifferent(this.initialForm.value, this.estateAgentDetails.value))
    {
      this.auditService.auditForm(this.caseId, 'EstateAgentDetails', this.initialForm.value, this.estateAgentDetails.value).subscribe((response : any) => {
        this.activeModal.close(true);
      });
    }
    else
      this.activeModal.dismiss();
  }

  openAuditForForm(){
    const modalRef = this.modalService.openWithOptions(AuditFormComponent, {size: 'xl'});
    modalRef.componentInstance.caseId = this.caseId;
    modalRef.componentInstance.formName = "EstateAgentDetails";

  }

}
